import { StaffQualificationEnum } from '../../lib/types/enums/staff/staff-qualifications.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type CenterRequestedStaffSlot = {
  staffRequestId: number
  qualification: StaffQualificationEnum
  numberOfStaff: number
  affectedCount: number
  unfilledCount: number
}

export function getCenterRequestedStaffSlots(centerId: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getCenterRequestedStaffSlots.url, { centerId }))
    .get<CenterRequestedStaffSlot[]>()
}
